const SUPPORTED_HOSTNAMES = [
  'images.fie.futurecdn.net',
  'cdn.mos.cms.futurecdn.net',
  'dev.mos.cms.futurecdn.net',
];
const QUALITY = 80;
// pattern `-number-number` before the extension
const LEGACY_PATTERN = /-(\d+)-(\d+)(?=\.[^/.]+(?:\.webp)?$)/;
const EXTENSION_PATTERN = /(?=\.[^/.]+(?:\.webp)?$)/;

const updateV2 = (
  parsedUrl: URL,
  pathParts: string[],
  newWidth: number,
  onlyReplaceExistingSize: boolean,
): string => {
  const params = new Map<string, number>(
    pathParts[2].split(',').map((p) => {
      const [k, v] = p.split(':');
      return [k, Number(v)];
    }),
  );

  if (onlyReplaceExistingSize && !params.has('w')) {
    return parsedUrl.toString();
  }

  // overwrite / insert in guaranteed order
  params.delete('w');
  params.delete('q');
  params.set('w', newWidth);
  params.set('q', QUALITY);

  pathParts[2] = [...params.entries()].map(([k, v]) => `${k}:${v}`).join(',');

  return `${parsedUrl.origin}${pathParts.join('/')}`;
};

const updateLegacy = (url: string, newWidth: number, onlyReplaceExistingSize: boolean): string => {
  if (LEGACY_PATTERN.test(url)) {
    return url.replace(LEGACY_PATTERN, `-${newWidth}-${QUALITY}`);
  }

  if (onlyReplaceExistingSize) {
    return url;
  }

  return url.replace(EXTENSION_PATTERN, `-${newWidth}-${QUALITY}`);
};

export const updateImageSize = (
  url: string,
  newWidth: number,
  onlyReplaceExistingSize = false,
): string => {
  try {
    const parsedUrl = new URL(url);

    if (!SUPPORTED_HOSTNAMES.includes(parsedUrl.hostname)) {
      return url;
    }

    const pathParts = parsedUrl.pathname.split('/');
    return pathParts[1] === 'v2'
      ? updateV2(parsedUrl, pathParts, newWidth, onlyReplaceExistingSize)
      : updateLegacy(url, newWidth, onlyReplaceExistingSize);
  } catch (error) {
    return url;
  }
};
